import { GeographicRegion, State } from "../../../api/calendarEvent";
import DSAutocomplete from "../../system-design/DSAutocomplete";
import DSCircularProgress from "../../system-design/DSCircularProgress";
import DSListItem from "../../system-design/DSListItem";
import DSTextField from "../../system-design/DSTextField";
import useStateDropdown from "../hooks/useStateDropdown";

export type StateDropdownProps = {
  country: GeographicRegion | null;
  initialState?: State | null;
  onSelect: (state: State | null) => void;
  disabled?: boolean;
};

const StateDropdown = ({
  country,
  initialState,
  onSelect,
  disabled = false,
}: StateDropdownProps) => {
  const {
    options,
    handleInputChange,
    isLoading,
    selectedState,
    handleOptionSelect,
    hasStates,
  } = useStateDropdown({ country, initialState, onSelect });

  const isDisabled = disabled || !country || !hasStates;

  return (
    <DSAutocomplete
      options={options}
      value={selectedState}
      onChange={handleOptionSelect}
      onInputChange={handleInputChange}
      getOptionLabel={(option) => option.name}
      disabled={isDisabled}
      renderOption={(props, option) => (
        <DSListItem {...props} key={option.iso}>
          {option.name}
        </DSListItem>
      )}
      renderInput={(params) => (
        <DSTextField
          {...params}
          fullWidth
          label="State/Province"
          placeholder={
            !country
              ? "Select a country first..."
              : !hasStates
                ? "No states available"
                : "Select a state/province..."
          }
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <DSCircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default StateDropdown;
